import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { EncryptionContextProvider } from "./components/EncryptionContext";
import Navbar from "./components/Navbar";
import MobileNav from "./components/MobileNav";
import Footer from "./components/Footer";
import JournalApp from "./components/JournalApp";
import Home from "./components/Home";
import About from "./components/About";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import NewsletterSignupPage from "./components/NewsletterSignupPage";
import CMS from "./components/CMS";
import LoginPage from "./components/LoginPage";

// New component to handle content and footer logic
function AppContent() {
  const location = useLocation(); // Now safe to use within <Router>

  const journalPaths = [
    "/cycles",
    "/journal",
    "/prompts",
    "/schedule",
    "/previous",
    "/settings",
  ];

  return (
    <div className="min-h-screen flex flex-col justify-start overflow-x-hidden">
      <Navbar />
      {!journalPaths.includes(location.pathname) && <MobileNav />}
      <main className="flex-1">
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/newsletter" element={<NewsletterSignupPage />} />
          <Route path="/cms" element={<CMS />} />

          {/* Authentication */}
          <Route path="/login" element={<LoginPage />} />

          {/* Journal experience */}
          <Route path="/cycles" element={<JournalApp initialTab="cycles" />} />
          <Route path="/journal" element={<JournalApp initialTab="journal" />} />
          <Route path="/prompts" element={<JournalApp initialTab="prompts" />} />
          <Route path="/schedule" element={<JournalApp initialTab="schedule" />} />
          <Route path="/previous" element={<JournalApp initialTab="previous" />} />
          <Route path="/settings" element={<JournalApp initialTab="settings" />} />
        </Routes>
      </main>
      {location.pathname !== "/cycles" && <Footer />} {/* Conditionally render Footer */}
    </div>
  );
}

function App() {
  return (
    <EncryptionContextProvider>
      <Router>
        <AppContent /> {/* Render content within Router */}
      </Router>
    </EncryptionContextProvider>
  );
}

export default App;